export const calculatePaginator = (page: number, rowsPerPage: number) => ({
  offset: rowsPerPage ? rowsPerPage * (page - 1) : rowsPerPage,
  limit: rowsPerPage,
})
